import React from 'react';

import { usePipelineTagsTableContext } from 'app/settings/tags-page/context/PipelineTagsTableContext';
import pipelineTagsTableColumns from './pipelineTagsTableColumns';
import PipelineTagsTableTitle from './PipelineTagsTableTitle';
import AddTagButton from './AddTagButton';

const STATIC_TABLE_PROPS = {
  columns: pipelineTagsTableColumns,
  sortServer: true,
  paginationDefaultPage: 1,
};

export default function usePipelineTagsTableProps() {
  const { tags, pagination, loading, perPage, resetPagination, setActivePage, onSort } = usePipelineTagsTableContext();

  return {
    ...STATIC_TABLE_PROPS,
    title: <PipelineTagsTableTitle />,
    actions: <AddTagButton />,
    data: tags,
    pagination,
    loading,
    perPage,
    onSort,
    paginationResetDefaultPage: resetPagination,
    onFetchPage: setActivePage,
  };
}
